import React, { useState } from "react";
import { Filter } from "pepsico-ds";
import { Box, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { boxStyle } from "../InternalPages/InternalStyle";
import CustomSearch from "../../utils/CustomSearch/CustomSearch";
import { setSectorLibraryFilter } from "../../slices/LibraryPageSlice";
import { RenderGridButtons } from "../InternalPages/InternalFilter";
import { handleSectorSelection } from "../../utils/function";

export default function LibraryFilter({
  setGrid,
  header,
  grid,
  setSearchTextData,
  setCropType,
  setCountryFilter,
  setLanguageFilter,
  setLocalSector,
  localSector,
}) {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const dispatch = useDispatch();

  const isDarkTheme = useSelector((state) => state.theme);

  const { variety } = useSelector((state) => state.internalPage);

  const {
    sectorFilter,
    countryFilter,
    laguageFilter,
    cropTypeFilter,
    sectorAndCountry,
  } = useSelector((store) => store.internalFilter);
  const [countries, setCountries] = useState(countryFilter);

  const handleSelectedCrop = (selectedCrop) => {
    setCropType(selectedCrop);
  };

  const handleSelectedCountry = (countryName) => {
    setCountryFilter(countryName);
  };
  const handleSearch = (value) => {
    setSearchTextData(value);
  };

  const handleSelect = (view) => {
    setGrid(view);
  };
  const handleLanguage = (language) => {
    setLanguageFilter(language);
  };

  return (
    <Box
      sx={
        isMobile
          ? {
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              width: "100%",
            }
          : { display: "flex", justifyContent: "space-between", width: "100%" }
      }
    >
      <Box sx={boxStyle}>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <Filter
            label={
              <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                Crop Type
              </span>
            }
            onChange={handleSelectedCrop}
            options={(cropTypeFilter || [])?.map((item) => ({
              id: item.id,
              label: item.name,
            }))}
            selection="single"
            size="medium"
            isDark={isDarkTheme}
          />

          <Filter
            label={
              <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                Sector
              </span>
            }
            onChange={(sector) =>
              handleSectorSelection(
                sector,
                localSector,
                setLocalSector,
                dispatch,
                setCountries,
                countryFilter,
                sectorAndCountry,
                setSectorLibraryFilter
              )
            }
            options={(sectorFilter || [])?.map((item) => ({
              id: item.id,
              label: item.name,
            }))}
            selection="single"
            size="medium"
            isDark={isDarkTheme}
            value={localSector}
          />

          <Filter
            label={
              <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                Country
              </span>
            }
            onChange={handleSelectedCountry}
            options={(countries || [])?.map((item) => ({
              id: item.id,
              label: item.name,
            }))}
            selection="single"
            size="medium"
            isDark={isDarkTheme}
          />

          <Box sx={{ display: "flex", gap: 2 }}>
            <Filter
              label={
                <span style={{ fontFamily: "Inter", fontSize: "14px" }}>
                  Language
                </span>
              }
              onChange={handleLanguage}
              options={(laguageFilter || [])?.map((item) => ({
                id: item.id,
                label: item.name,
              }))}
              selection="single"
              size="medium"
              isDark={isDarkTheme}
              value={variety}
              dropdownPosition="bottom"
            />
          </Box>
        </Box>
      </Box>
      <Box
        sx={
          isMobile
            ? { display: "flex", justifyContent: "space-between" }
            : { display: "flex", flexDirection: "row", gap: "16px" }
        }
      >
        <CustomSearch handleSearch={handleSearch} data-testid="search" />
        {header !== "Library" && (
          <RenderGridButtons
            grid={grid}
            handleSelect={handleSelect}
            data-testid="grid-toggle-button"
          />
        )}
      </Box>
    </Box>
  );
}
